import { API_BASE_URL } from '../config';
import * as Sentry from "@sentry/react";

export const fetchWithAuth = async (url, options = {}) => {
  if (!url.startsWith('http')) {
    const baseUrl = API_BASE_URL.endsWith('/') ? API_BASE_URL.slice(0, -1) : API_BASE_URL;
    // Callers pass either a bare path ('users') or an already-prefixed one (`${API_BASE_URL}/me`)
    if (!url.startsWith(`${baseUrl}/`)) {
      url = `${baseUrl}/${url.startsWith('/') ? url.substring(1) : url}`;
    }
  }

  const headers = {
    ...options.headers || {},
  };

  if (localStorage.getItem('userAuthToken')) {
    headers['Authorization'] = `Bearer ${localStorage.getItem('userAuthToken')}`;
  }

  try {
    const response = await fetch(url, {
      ...options,
      headers,
    });

    // Capture API errors with backend errorCode
    if (!response.ok && response.status >= 500) {
      const errorData = await response.clone().json().catch(() => ({}));

      Sentry.captureException(new Error(`API Error: ${errorData.error || response.statusText}`), {
        level: 'error',
        tags: {
          http_status: response.status,
          error_code: errorData.errorCode,
        },
        extra: {
          backend_error: errorData.error,
          backend_details: errorData.details,
        }
      });
    }

    return response;
  } catch (error) {
    // Abort is an expected control-flow in the UI (e.g. debounced / superseded requests).
    // Do not report it as a network error to Sentry.
    if (error?.name === 'AbortError') {
      throw error;
    }

    // Only capture network errors (fetch failures)
    Sentry.captureException(error, {
      level: 'error',
      tags: {
        error_type: 'network_error',
      }
    });

    throw error;
  }
};